// Инструкция к применению:
// Смотрим на сообщение, которое приходит с бэка и нужно локализировать
// 'User "Federiko" cannot upgrade to "god_story" plan' - переменные оборачиваем и добавляем ключ локали, получается
// 'User {userName} cannot upgrade to {plan} plan': 'BACKEND_MESSAGES.CANNOT_UPGRADE_PLAN'

export const MESSAGE_TO_KEY: Record<string, string> = {
  'Bad Request: boostyEmail must be an email': 'COMMON.ERRORS.INVALID_EMAIL',
  'Bad Request: Slug {slug} is already taken by another user': 'BACKEND_MESSAGES.SLUG_ALREADY_TAKEN',
  'Bad Request: You have already reported this user': 'BACKEND_MESSAGES.ALREADY_REPORT_USER',
  'Boosty email successfully linked to your account': 'BLOCKS.SUBSCRIBE_BOOSTY.BACKEND_SUCCESSFULLY_NOTIFICATION',
  'Cannot create chat with paid model. You need tokens or an active paid subscription to use paid models.':
    'BACKEND_MESSAGES.CANNOT_CREATE_CHAT_WITH_PAID_MODEL',
  'Forbidden: Cannot create chat with paid model. You need tokens or an active paid subscription to use paid models.':
    'BACKEND_MESSAGES.CANNOT_CREATE_CHAT_WITH_PAID_MODEL',
  'Forbidden: Invalid password': 'BACKEND_MESSAGES.INVALID_PASSWORD',
  'Forbidden: Selected model is not available for this character. Free models are blocked for this character. Total context ({number} tokens) exceeds limit (5000). Please use a paid model.':
    'BACKEND_MESSAGES.TOKENS_EXCEEDED',
  'Forbidden: You do not have enough tokens to generate this image': 'BACKEND_MESSAGES.NOT_ENOUGH_TOKENS',
  'Not Found: Payment order with ID "{id}" not found': 'BACKEND_MESSAGES.TRANSACTION_ID_NOT_FOUND',
  'Payment provider error: No available payment system': 'BACKEND_MESSAGES.PAYMENT_PROVIDER.NO_PAYMENT_SYSTEMS',
  'Payment provider error: Unknown error from BetaTransfer': 'BACKEND_MESSAGES.PAYMENT_PROVIDER.NO_PAYMENT_SYSTEMS',
  'Selected model is not available for this character. Free models are blocked for this character. Total context ({number} tokens) exceeds limit (5000). Please use a paid model.':
    'BACKEND_MESSAGES.TOKENS_EXCEEDED',
  'Ошибка авторизации: Invalid backup code': 'MODALS.PROFILE_SETTINGS.SECURITY.TWO_FACTOR.INVALID_CODE',
  'Ошибка авторизации: Invalid code': 'MODALS.PROFILE_SETTINGS.SECURITY.TWO_FACTOR.INVALID_CODE',
};

/**
 * Регулярное выражение для поиска переменных в шаблоне вида {variableName}
 * Пример: в строке "User {name} tried {action}" найдет ['name', 'action']
 */
export const TEMPLATE_VARIABLE_PATTERN = /\{([^}]+)\}/g;

/**
 * Регулярное выражение для замены экранированных переменных \{variableName\} на захватывающие группы (.+?)
 * Используется после escapeRegex для создания паттерна сопоставления
 */
export const ESCAPED_VARIABLE_PATTERN = /\\{[^}]+\\}/g;

/**
 * Регулярное выражение для экранирования специальных символов regex
 * Экранирует символы: . * + ? ^ $ { } ( ) | [ ] \
 */
export const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;

/**
 * Захватывающая группа для regex, которая соответствует любому тексту (нежадная)
 * Используется для замены переменных в шаблоне на паттерн, который захватит их значение
 * Пример: "User {name}" -> "User (.+?)" -> захватит любое имя пользователя
 */
export const CAPTURING_GROUP_PATTERN = '(.+?)';

/**
 * Паттерн замены для экранирования специальных символов regex
 * $& вставляет найденное совпадение с обратным слешем перед ним
 * Пример: "test." -> "test\\."
 */
export const ESCAPE_REPLACEMENT = '\\$&';
